import "./App.css";
import Wheather from "./components/Wheather/Wheather";
import Ex1 from "./components/Practice/Ex1";
import Ex2 from "./components/Practice/Ex2";

const App = () => {
  return (
    <>
      <Wheather />
      {/*<Ex1 />*/}
      {/*<Ex2 />*/}
    </>
  );
};

export default App;
